import React from "react";
import { useSelector } from "react-redux";
import { DragescentState } from "../../../../store/reducers/stateType";
import { SlotType } from "../../../../lib/types";

interface IProps {
  buildingDamage: string;
}

const DetailBuildingDamage = ({
  buildingDamage
}: IProps) => {
  const allBuildings = useSelector((state: DragescentState) => state.governorate.allBuildings);
  return (<>
    {buildingDamage.split(";")
      .filter(Boolean)
      .map(b => b.includes(":") && <div>
        <em>
          {allBuildings
            .find((building: SlotType) => building.id.toString(10) === b
              .split(":")[0])?.name || "unknown"}
        </em>: {b.split(":")[1]}HP</div>)}
  </>)
};

export default DetailBuildingDamage;
